import { v4 as uuid } from 'uuid';
import { isShallowEqual } from '@atlassian/jira-platform-shallow-equal/src/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createContainer } from '@atlassian/react-sweet-state';
import { fg } from '@atlassian/jira-feature-gating';
import { actions, handleSearchInputUpdate } from './actions.tsx';
import type { State, Actions, Props } from './types.tsx';

const initialState: State = {
	disposables: [],
	isFetching: false,
	isFetchingView: false,
	isRefreshing: false,
	isNetworkError: false,
	searchKey: '',
	totalIssueCount: null,
	totalIssueCountIsFetching: false,
	totalIssueCountIsError: false,
	inFlightIssueSearchInput: null,
};

export const IssueSearchServiceContainer = createContainer<Props>();

export const Store = createStore<State, Actions, Props>({
	name: 'IssueSearchServiceStore',
	initialState,
	actions,
	containedBy: IssueSearchServiceContainer,
	handlers: {
		onInit:
			() =>
			({ setState }) => {
				setState({
					searchKey: uuid(),
				});
			},
		onContainerUpdate:
			(nextProps, prevProps) =>
			({ dispatch, getState }) => {
				if (
					isShallowEqual(nextProps.issueSearchInput, getState().inFlightIssueSearchInput) &&
					fg('jira_list_nin_merge_technical_changes')
				) {
					return;
				}

				if (!isShallowEqual(nextProps.issueSearchInput, prevProps.issueSearchInput)) {
					dispatch(handleSearchInputUpdate());
				}
			},
		onDestroy:
			() =>
			({ getState }) => {
				const { disposables } = getState();
				// Dispose of any manually retained operations when the container is unmounted
				disposables.forEach((disposable) => disposable.dispose());
			},
	},
});
